import AuthWebLayout from './AuthWebLayout';

export default AuthWebLayout;
